import React, { forwardRef } from "react";

import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';



const TextInput = forwardRef((props, ref) => {

    const { mandatory, ...rest } = props;



    return (
        <>
            {props.label && <Typography variant="subtitle2" >
                {props.label} <Typography variant="mandatory">{mandatory ? "*" : ""}</Typography>
            </Typography>}
            <InputBase
                variant={props.variant ? props.variant : "textInput"}
                ref={ref}
                {...rest}
            />

            {props.icon && <Typography className={props.className} >{props.icon}</Typography>}
        </>
    )

})

export default React.memo(TextInput)

